// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6sFBC","titleContainer":"styles_titleContainer__2Mv7m","holdPhone":"styles_holdPhone__2mBQT","content":"styles_content__1e7gw"};